import mixins from 'vue-typed-mixins';

import RoutesMixin from '@/entries/user/mixins/RoutesMixin';

export default mixins(RoutesMixin).extend({
  name: 'Unauthorized',
});
